var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('full-modal',{attrs:{"modal-title":_vm.reportType,"modal-name":"GLOBAL_REPORT_MODAL","no-padding":"reportType === 'RENT ROLL REPORT'"}},[_c(_vm.reportComponent,{tag:"component",attrs:{"reportTable":_vm.reportTable,"reportId":_vm.reportId,"reportType":_vm.reportType}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39abd902","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/reporting/GlobalDefaultReport.vue
// module id = AFd8
// module chunks = 0 1